import type { RefObject, ReactNode } from 'react';
import { ExportProvider } from '@/contexts/ExportContext';

interface HiddenReportExportHostProps {
    exportRef: RefObject<HTMLDivElement | null>;
    children: ReactNode;
    width?: number;
}

const HiddenReportExportHost = ({ exportRef, children, width = 1280 }: HiddenReportExportHostProps) => (
    <div aria-hidden="true" className="pointer-events-none fixed -top-[200vh] -left-[200vw] opacity-0">
        <div style={{ width }} ref={exportRef}>
            <ExportProvider value={true}>{children}</ExportProvider>
        </div>
    </div>
);

export default HiddenReportExportHost;
